import { render, staticRenderFns } from "./start-live-set.vue?vue&type=template&id=81c8625e&scoped=true"
import script from "./start-live-set.vue?vue&type=script&lang=js"
export * from "./start-live-set.vue?vue&type=script&lang=js"
import style0 from "./start-live-set.vue?vue&type=style&index=0&id=81c8625e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c8625e",
  null
  
)

export default component.exports